






















import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import { ErrorCode } from '@/utils/response';
import {
  SubscriptionType,
  checkCoupon,
} from '@/utils/subscription/subscription.util';
import { Coupon } from '@/resource/coupon/coupon.model';

@Component({
  components: {
    Modal,
    Form,
  },
})
export default class ModalDiscount extends Vue {
  @Prop({ required: true })
  updateSelectedCoupon: (coupon: Coupon) => void;

  @Prop({ required: true })
  subscriptionType!: SubscriptionType;

  openModal: any = null;
  closeModal: any = null;

  inputs: InputData[] = [
    {
      name: 'discountCode',
      value: '',
      placeholder: 'Discount Code (E.g. ZAF10)',
      type: 'text',
      isRequired: true,
    },
  ];

  mounted() {
    this.$emit('ModalDiscountAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async onSubmit(bodyRequest: any): Promise<OnSubmitReturn | null> {
    const code = bodyRequest.discountCode;

    const verifiedCode = await checkCoupon({
      coupon: code,
      subscriptionType: this.subscriptionType,
    });

    if (verifiedCode) {
      this.updateSelectedCoupon && this.updateSelectedCoupon(verifiedCode);
      return null;
    } else {
      return {
        error: {
          message: 'Discount code tidak valid.',
          code: ErrorCode.ValidationError,
          errors: [],
        },
      };
    }
  }
}
